import type { CSSProperties, ReactNode } from 'react'
import { cx } from './utils/cx'

// SnapTransfer extension — not part of the reference component library.
// Used for validation errors, tier-limit breaches, and unexpected states the
// user must see inline with a form/field. Styles live in components.css under
// .st-hot-alert so no caller re-declares the hot/ink/mono tokens.
export function HotAlert({
  children,
  className,
  style
}: {
  children?: ReactNode
  className?: string
  style?: CSSProperties
}) {
  return (
    <div className={cx('st-hot-alert', className)} style={style} role="alert">
      {children}
    </div>
  )
}
